import React from "react";
import { Link } from "react-router-dom";
import HostLeaguesSection from "./HostLeaguesSection";
import MatchmakingSection from "./MatchmakingSection";

export function LeaguesPage({ onToast, onRequireAuth, onRequireProfile, openCreateOnMount, onOpenLeague }) {
  return (
    <main className="page-z" data-testid="leagues-page">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 pt-10">
        <Link to="/" data-testid="leagues-back-home" className="inline-flex items-center gap-2 text-xs tracking-widest text-[#a3a3ac] hover:text-[#14b8a6]">
          <i className="fas fa-arrow-left" /> BACK TO ROADMAP
        </Link>
      </div>

      {/* CREATE LEAGUE button + your hosted leagues live at the very top
          so launching/managing a league is one click from /leagues. */}
      <HostLeaguesSection
        onToast={onToast}
        onRequireAuth={onRequireAuth}
        onRequireProfile={onRequireProfile}
        openCreateOnMount={openCreateOnMount}
        onOpenLeague={onOpenLeague}
      />

      {/* Discover — public search/filter of every league anyone has created. */}
      <MatchmakingSection
        onToast={onToast}
        onRequireAuth={onRequireAuth}
        onOpenLeague={onOpenLeague}
      />
    </main>
  );
}
export default LeaguesPage;
